module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG33135e0a938382b6b6e1631066071644.33135e0a.png";